<template>
  <section class="section-block">
    <SectionTitle title="預約者備註欄位設定" @edit="modal.edit = true" />
    <BobDisplayForm
      :config="displayConfig"
      :fields="displayFields"
      :content-classes="['text-gray-80', 'text-sub']"
    />

    <EditAppointmentUserCommentSettingsModal
      v-if="modal.edit"
      :configData="configData"
      @close="modal.edit = false"
      @refresh="$emit('refresh')"
    />
  </section>
</template>

<script>
import { computed, defineComponent, reactive } from 'vue'
import { get } from 'lodash'
import BobDisplayForm from '@/components/BobDisplayForm.vue'
import SectionTitle from '@/components/Title/SectionTitle.vue'
import EditAppointmentUserCommentSettingsModal from './components/EditAppointmentUserCommentSettingsModal.vue'

const DEFAULT_USER_COMMENT_PLACEHOLDER = '請輸入備註'

export default defineComponent({
  name: 'AppointmentUserCommentSettings',
  components: {
    BobDisplayForm,
    SectionTitle,
    EditAppointmentUserCommentSettingsModal,
  },
  props: {
    configData: {
      type: Object,
      default: () => ({}),
    },
  },
  emits: ['refresh'],
  setup (props) {
    const modal = reactive({
      edit: false,
    })

    const displayConfig = {
      labelWidth: '250px',
      rowGap: 28,
    }

    const displayFields = computed(() => {
      return [
        {
          prop: 'userCommentHint',
          label: '備註提示文字',
          body: {
            component: 'span',
            render: () => get(props.configData, 'userCommentSetting.userCommentHint', '尚未設定'),
          },
        },
        {
          prop: 'userCommentPlaceholder',
          label: '範例文字',
          body: {
            component: 'span',
            render: () => get(
              props.configData,
              'userCommentSetting.userCommentPlaceholder',
              DEFAULT_USER_COMMENT_PLACEHOLDER,
            ),
          },
        },
        {
          prop: 'userCommentRequired',
          label: '欄位必填',
          body: {
            component: 'span',
            render: () => get(props.configData, 'userCommentSetting.userCommentRequired', false)
              ? '開啟'
              : '關閉',
          },
        },
      ]
    })

    return {
      modal,
      displayConfig,
      displayFields,
    }
  },
})
</script>
